const API_URLS = {
    GLOBAL: process.env.REACT_APP_API_SERVER_URL,
};

function apiUrl(SERVICE) {
    return API_URLS[SERVICE] ? API_URLS[SERVICE] : API_URLS['GLOBAL']
}

export default apiUrl;